define("ember-cli-clipboard/modifiers/clipboard", ["exports", "ember-modifier", "clipboard", "@ember/utils", "@ember/string", "@ember/object/internals"], function (_exports, _emberModifier, _clipboard, _utils, _string, _internals) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"clipboard",0,"@ember/utils",0,"@ember/string",0,"@ember/object/internals",0,"@embroider/macros"eaimeta@70e063a35619d71f
  const CLIPBOARD_EVENTS = ['success', 'error'];
  function clipboard(element, params, hash) {
    const {
      action = 'copy',
      container,
      /*
       * delegateClickEvent true - scope event listener to this element
       * delegateClickEvent false - scope event listener to document.body (ClipboardJS)
       */
      delegateClickEvent = true,
      target,
      text
    } = hash;
    element.setAttribute('data-clipboard-action', action);
    if (!(0, _utils.isBlank)(text)) {
      element.setAttribute('data-clipboard-text', text);
    }
    if (!(0, _utils.isBlank)(target)) {
      element.setAttribute('data-clipboard-target', target);
    }
    if ((0, _utils.isBlank)(element.dataset.clipboardId)) {
      element.setAttribute('data-clipboard-id', (0, _internals.guidFor)(element));
    }
    const trigger = delegateClickEvent === false ? element : `[data-clipboard-id=${element.dataset.clipboardId}]`;
    const clipboard = new _clipboard.default(trigger, {
      text: typeof text === 'function' ? text : undefined,
      container: typeof container === 'string' ? document.querySelector(container) : container,
      target
    });
    CLIPBOARD_EVENTS.forEach(event => {
      clipboard.on(event, () => {
        if (!element.disabled) {
          const action = hash[`on${(0, _string.capitalize)(event)}`];
          action?.(...arguments);
        }
      });
    });
    return () => clipboard.destroy();
  }
  let clipboardModifier;
  {
    clipboardModifier = (0, _emberModifier.modifier)(clipboard);
  }
  var _default = _exports.default = clipboardModifier;
});